import { Text, VStack, HStack, Box, Pressable } from 'native-base'; 
import { COLORS } from '../../../utils/colors';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../../utils/fonts';
import CustomButton from '../../../components/button';
import { useEffect, useState } from 'react';
import RadioButtons from '../../../components/radioButton';
import { Toaster } from '../../../components/toaster';
import ContainerCards from "../../../components/cards";
import { approvedIconSvg } from '../../../utils/svg';
import CustomModal from '../../../components/modal';
import NewTextAreaField from '../../../components/textArea/newTextArea';
import AttachmentsCards from '../../../containers/attachmentCards';
import config from '../../../utils/config';
import AccordionDetail from '../../../components/accordion';

export const AgencyApproval = ({
  eventsDetail,
  approveAgencyWorkflow,
  getEventDetails,
}) => {
  const toaster = Toaster();
  const [options, setOptions] = useState({});
  const [selected, setSelected] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedAgencyId, setSelectedAgencyId] = useState(null);
  const [approvalReason, setApprovalReason] = useState('');
  const [rejectionReasons, setRejectionReasons] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showReasonPopup, setShowReasonPopup] = useState(false);
  const [selectedReasonData, setSelectedReasonData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState('');
  const [forceRemount, setForceRemount] = useState(0);

  useEffect(() => {
    if (eventsDetail.agency) {
      getAgencyList(eventsDetail.agency);
    }
  }, [eventsDetail]);

  function addTimeAndFormat() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    const formattedMilliseconds = milliseconds.padEnd(6, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${formattedMilliseconds}`;
  }

  const getAgencyList = (agencies) => {
    let agencyData = [];
    let approved = 0;
    agencies &&
      agencies.map((agency) => {
        if (agency.status !== 'null') {
          approved = approved + 1;
        }
        let path = {};
        if (agency.quotation_path) {
          path = agency.quotation_path;
        }

        agencyData.push({
          id: agency.id,
          name: agency.name,
          status: agency.status,
          emailId: agency.emailId,
          path: path,
          reason: agency.reason || '', // Add reason field
        });
      });

    if (agencies.length === approved) {
      setSelected(true);
    }

    let radioOptions = {};
    let types = [];
    agencyData?.map((item) => {
      return types.push({
        text: item.name,
        value: 'agency_' + item.id,
        status: item.status,
        path: item.path,
        emailId: item.emailId,
        reason: item.reason, // Add reason to radio options
      });
    });
    radioOptions.types = types;
    radioOptions.selected = '';
    setOptions(radioOptions);
  };

  const handleOptionChange = (e) => {
    let selectedValue = e.target.value;
    let selectedOption = { ...options, selected: selectedValue };
    selectedOption.selected = selectedValue;
    setOptions(selectedOption);
  };

  const handleApproveClick = () => {
    if (options.selected === '') {
      toaster('Please choose agency', 'error', 'error');
      return;
    }
    
    if (!eventsDetail?.agency || !Array.isArray(eventsDetail.agency)) {
      toaster('Agency data not available', 'error', 'error');
      return;
    }
    
    const selectedId = options.selected.split('agency_')[1];
    setSelectedAgencyId(selectedId);
    
    // Initialize rejection reasons for all other agencies
    const rejectionReasonsObj = {};
    eventsDetail.agency.forEach(agency => {
      if (agency.id !== selectedId) {
        rejectionReasonsObj[agency.id] = '';
      }
    });
    setRejectionReasons(rejectionReasonsObj);
    setApprovalReason('');
    setShowReasonModal(true);
    
    // Scroll to modal after it opens
    setTimeout(() => {
      const modalElement = document.querySelector('[role="dialog"]');
      if (modalElement) {
        modalElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }, 100);
  };

  const handleReasonSubmit = async () => {
    if (!approvalReason.trim()) {
      toaster('Please enter approval reason', 'error', 'error');
      return;
    }

    if (!eventsDetail?.agency || !Array.isArray(eventsDetail.agency)) {
      toaster('Agency data not available', 'error', 'error');
      return;
    }

    // Check if all rejection reasons are filled
    const missingReasons = Object.keys(rejectionReasons).filter(
      agencyId => !rejectionReasons[agencyId].trim()
    );
    
    if (missingReasons.length > 0) {
      toaster('Please enter rejection reasons for all agencies', 'error', 'error');
      return;
    }

    setIsSubmitting(true);
    
    try {
      let payload = { ...eventsDetail };
      let agency = [];
      
      payload.agency.map((item) => {
        let status = 'inactive';
        let reason = '';
        
        if (item.id === selectedAgencyId) {
          status = 'active';
          reason = approvalReason;
        } else {
          reason = rejectionReasons[item.id] || '';
        }
        
        agency.push({
          id: item.id,
          name: item.name,
          status: status,
          quotation_path: item.quotation_path ? item.quotation_path : {},
          emailId: item.emailId,
          reason: reason, // Add reason to each agency
        });
      });
      
      let instance_id = payload['_id'];
      payload.agency = agency;
      payload.workflow_instance_id = payload['_id'];
      delete payload['_id'];
      payload.approved_at = addTimeAndFormat();
      
      await approveAgencyWorkflow(
        payload,
        eventsDetail.current_step,
        instance_id,
        'ASSIGN'
      );
      
      await getEventDetails(eventsDetail._id);
      setShowReasonModal(false);
      toaster('Agency approved successfully', 'success', 'success');
    } catch (error) {
      toaster('Failed to approve agency', 'error', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeReasonModal = () => {
    setShowReasonModal(false);
    setSelectedAgencyId(null);
    setApprovalReason('');
    setRejectionReasons({});
    setForceRemount(prev => prev + 1);
  };

  const handleReasonIconClick = (agency) => {
    if (agency.reason && agency.reason.trim()) {
      setSelectedReasonData({
        name: agency.name,
        reason: agency.reason,
        status: agency.status
      });
      setShowReasonPopup(true);
    }
  };

  const closeReasonPopup = () => {
    setShowReasonPopup(false);
    setSelectedReasonData(null);
  };

  const getSelectedAgencyName = () => {
    if (!selectedAgencyId || !eventsDetail?.agency || !Array.isArray(eventsDetail.agency)) return '';
    const agency = eventsDetail.agency.find(a => a.id === selectedAgencyId);
    return agency ? agency.name : '';
  };

  const getRejectedAgencies = () => {
    if (!eventsDetail?.agency || !Array.isArray(eventsDetail.agency)) {
      return [];
    }
    return eventsDetail.agency.filter(a => a.id !== selectedAgencyId);
  };

  const modalHeader = () => {
    return <>Agency Approval</>;
  };

  const modalBody = () => {
    return (
      <VStack space={4} width="100%" maxH="60vh" overflowY="auto">
        {/* Approved Agency Section */}
        <Box>
          <Text
            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
            color={COLORS.APPROVE_TEXT_COLOR}
            mb={2}
          >
            Approved Agency: {getSelectedAgencyName()}
          </Text>
          <NewTextAreaField
            name="approvalReason"
            value={approvalReason}
            onChange={(e, name) => setApprovalReason(e.target.value)}
            placeholder="Enter approval reason..."
            width="100%"
            forceRemount={forceRemount}
          />
        </Box>

        {/* Rejected Agencies Section */}
        {getRejectedAgencies().length > 0 && (
          <Box>
            <Text
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              color={COLORS.REJECT_TEXT_COLOR}
              mb={2}
            >
              Rejected Agencies
            </Text>
            <VStack space={3}>
              {getRejectedAgencies().map((agency) => (
                <Box key={agency.id}>
                  <Text
                    fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                    fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                    color={COLORS.ACCORDION_TITLE_COLOR}
                    mb={1}
                  >
                    {agency.name}
                  </Text>
                  <NewTextAreaField
                    name={`rejection_${agency.id}`}
                    value={rejectionReasons[agency.id] || ''}
                    onChange={(e, name) => 
                      setRejectionReasons(prev => ({
                        ...prev,
                        [agency.id]: e.target.value
                      }))
                    }
                    placeholder="Enter rejection reason..."
                    width="100%"
                    forceRemount={forceRemount}
                  />
                </Box>
              ))}
            </VStack>
          </Box>
        )}
      </VStack>
    );
  };

  const modalFooter = () => {
    return (
      <HStack justifyContent="end" width="100%" space={4}>
        <CustomButton
          onPress={closeReasonModal}
          text="Cancel"
          color={COLORS.MODAL_BACK_BUTTON_COLOR}
          variant="outline"
        />
        <CustomButton
          onPress={handleReasonSubmit}
          text={isSubmitting ? "Submitting..." : "Confirm"}
          color={COLORS.WHITE_COLOR}
          isLoading={isSubmitting}
        />
      </HStack>
    );
  };



  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderAgencyWithReasonIcon = (agency, index) => {
    const isSelected = options.selected === `agency_${agency.id}`;
    const isActive = agency.status === 'active';
    const isInactive = agency.status === 'inactive';
    const hasReason = agency.reason && agency.reason.trim();
    
    return (
      <ContainerCards
        key={agency.id}
        padding={1}
        width="100%"
        maxW="100%"
        height="auto"
        borderRadius="10px"
        background={COLORS.AGENCY_CARD_COLOR}
        boxShadow="none"
        mb={3}
      >
        <HStack
          justifyContent="space-between"
          alignItems="center"
          pl={4}
          pr={4}
          w="100%"
        >
          <HStack
            space={1.5}
            className="radio-btns"
            w={agency.status !== "null" ? "65%" : "100%"}
            alignItems="center"
          >
            {agency.status === 'null' && (
              <input
                type="radio"
                value={`agency_${agency.id}`}
                checked={isSelected}
                onChange={handleOptionChange}
                className="radio-btns"
              />
            )}
            <Text
              color={COLORS.PARTNERS_HEADING_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
              fontWeight={COMMONFONTSIZE.SMALL_FONT_WEIGHT}
              p="8px"
              flex={1}
            >
              {index + 1}. {agency.name}
            </Text>
            {hasReason && (
              <Pressable onPress={() => handleReasonIconClick(agency)}>
                <Box
                  bg={isActive ? COLORS.APPROVE_TEXT_COLOR : COLORS.REJECT_TEXT_COLOR}
                  borderRadius="50%"
                  width="20px"
                  height="20px"
                  justifyContent="center"
                  alignItems="center"
                  _hover={{ opacity: 0.8 }}
                >
                  <Text
                    color={COLORS.WHITE_COLOR}
                    fontSize="12px"
                    fontWeight="bold"
                  >
                    i
                  </Text>
                </Box>
              </Pressable>
            )}
          </HStack>
          
          {isInactive && (
            <HStack alignItems="center" space={2}>
              <Text
                width="fit-content"
                bgColor="none"
                color={COLORS.REJECT_TEXT_COLOR}
                fontWeight={COMMONFONTSIZE.SMALL_FONT_WEIGHT}
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              >
                Rejected
              </Text>
            </HStack>
          )}
        </HStack>
        {Object.keys(agency.path || {}).length > 0 && (
          <Box p="10px" width="100%">
            <AttachmentsCards
              fileName={agency.path.doc_type}
              fileSize={agency.path.file_size}
              path={config.bucketPath + agency.path?.file_name}
              timeline={agency.path.uploaded_time}
              attachments={true}
              translateY="-8px"
              height="fit-content"
              minW="300px"
            />
          </Box>
        )}
      </ContainerCards>
    );
  };

  const reasonPopupHeader = () => {
    return (
      <HStack justifyContent="space-between" alignItems="center" width="100%">
        <Text
          fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
          color={COLORS.BLACK_COLOR}
        >
          {selectedReasonData?.status === 'active' ? 'Approval Reason' : 'Rejection Reason'}
        </Text>
       
      </HStack>
    );
  };

  const reasonPopupBody = () => {
    if (!selectedReasonData) return null;
    
    return (
      <VStack space={4} width="100%">
        <Box>
          <Text
            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            fontWeight={COMMONFONTSIZE.SMALL_FONT_WEIGHT}
            color={COLORS.ACCORDION_TITLE_COLOR}
            mb={1}
          >
            Agency Name : {selectedReasonData.name}
          </Text>
          <Text
            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            fontWeight={COMMONFONTSIZE.SMALL_FONT_WEIGHT}
            color={COLORS.ACCORDION_TITLE_COLOR}
            mb={2}
          >
            Reason : {selectedReasonData.reason}
          </Text>
        </Box>
      </VStack>
    );
  };

  const reasonPopupFooter = () => {
    return (
      <HStack justifyContent="end" width="100%">
        <CustomButton
          onPress={closeReasonPopup}
          text="Close"
          color={COLORS.WHITE_COLOR}
        />
      </HStack>
    );
  };

  const contents = () => {
    let index = 0;
    return eventsDetail.agency.map((agency) => {
      if (agency.status === "inactive") {
        index++;
        return (
          <ContainerCards
            key={agency.id}
            padding={1}
            width="100%"
            maxW="100%"
            height="auto"
            borderRadius="10px"
            background={COLORS.AGENCY_CARD_COLOR}
            boxShadow="none"
            mb={3}
          >
            <HStack
              justifyContent="space-between"
              alignItems="center"
              pl={4}
              pr={4}
              w="100%"
            >
              <HStack space={1.5} className="radio-btns" w="100%" alignItems="center">
                <Text
                  color={COLORS.PARTNERS_HEADING_COLOR}
                  fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                  fontWeight={COMMONFONTSIZE.SMALL_FONT_WEIGHT}
                  p="16px"
                  pl="8px"
                  flex={1}
                >
                  {index}. {agency.name}
                </Text>
                {agency.reason && agency.reason.trim() && (
                  <Pressable onPress={() => handleReasonIconClick(agency)}>
                    <Box
                      bg={COLORS.REJECT_TEXT_COLOR}
                      borderRadius="50%"
                      width="20px"
                      height="20px"
                      justifyContent="center"
                      alignItems="center"
                      _hover={{ opacity: 0.8 }}
                    >
                      <Text
                        color={COLORS.WHITE_COLOR}
                        fontSize="12px"
                        fontWeight="bold"
                      >
                        i
                      </Text>
                    </Box>
                  </Pressable>
                )}
              </HStack>
              {/* <HStack alignItems="center" space={2}>
                <Text
                  width="fit-content"
                  bgColor="none"
                  color={COLORS.REJECT_TEXT_COLOR}
                  fontWeight={COMMONFONTSIZE.SMALL_FONT_WEIGHT}
                  fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                >
                  Rejected
                </Text>
              </HStack> */}
            </HStack>
            {Object.keys(agency.path || {}).length > 0 && (
              <Box p="10px" width="100%">
                <AttachmentsCards
                  fileName={agency.path.doc_type}
                  fileSize={agency.path.file_size}
                  path={config.bucketPath + agency.path?.file_name}
                  timeline={agency.path.uploaded_time}
                  attachments={true}
                  translateY="-8px"
                  height="fit-content"
                  minW="300px"
                />
              </Box>
            )}
          </ContainerCards>
        );
      }
    });
  };
  return (
    <>
      <VStack
        bg={COLORS.WHITE_COLOR}
        space={4}
        borderRadius={'8px'}
        w={'100%'}
        py={5}
        px={4}
      >
        <Text
          color={COLORS.ACCORDION_TITLE_COLOR}
          fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
        >
          Agency
        </Text>
        {!selected && (
          <Text color={COLORS.ACCORDION_TITLE_COLOR}>
            Which agency have you finalised ? Pick one and click on “Approve” CTA.
          </Text>
        )}
        {eventsDetail?.self_agency_approval === true && (
          <ContainerCards
            width="100%"
            maxW="100%"
            height="auto"
            borderRadius="10px"
            background={COLORS.AGENCY_CARD_COLOR}
            boxShadow="none"
          >
            <HStack space={2} pl={'16px'} py={'10px'} alignItems={"center"} style={
              {
                gap: '18px'
              }
            }>
              <Text
                fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                width={"100%"}
              >
                Self Agency
              </Text>
              <CustomButton
                text="Approved"
                startIcon={approvedIconSvg}
                width="fit-content"
                height="auto"
                bgColor="none"
                textColor={COLORS.APPROVE_TEXT_COLOR}
                fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              />
            </HStack>
          </ContainerCards>
        )}
        {/* Custom Agency Display with Reason Icons */}
        {eventsDetail?.agency && eventsDetail.agency.length > 0 && (
          <VStack space={3}>
            {/* Approved and Pending Agencies */}
            {eventsDetail.agency.filter(agency => agency.status !== 'inactive').map((agency, index) => 
              renderAgencyWithReasonIcon(agency, index)
            )}
            
            {/* Rejected Agencies Accordion */}
            {eventsDetail.agency.filter(agency => agency.status === 'inactive').length > 0 && (
              <AccordionDetail
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
                title="Rejected Agencies"
                content={contents()}
                type="agencies"
              />
            )}
          </VStack>
        )}
        {!selected && (
          <CustomButton
            onPress={handleApproveClick}
            text='Approve'
            width='100%'
          />
        )}
      </VStack>
      <CustomModal
        isOpen={showReasonModal}
        onClose={closeReasonModal}
        header={modalHeader()}
        body={modalBody()}
        footer={modalFooter()}
        width="600px"
        height="auto"
        top="50px"
        fixedPosition={true}
        fixedTop={50}
        scrollToTop={scrollToTop}
      />

      {/* Reason Popup Modal */}
      <CustomModal
        isOpen={showReasonPopup}
        onClose={closeReasonPopup}
        header={reasonPopupHeader()}
        body={reasonPopupBody()}
        footer={reasonPopupFooter()}
        width="500px"
        height="auto"
        top="50px"
        fixedPosition={true}
        fixedTop={50}
      />
    </>
  );
};
